export default "__VITE_ASSET__TA8j_yTd__"